// Admin routes for the Phase 7c basic slot `headless` (APPS-03 publishable keys, AI-02/05/06 drafts).
// Owned by P7c-basic; the router mounts whatever this returns under the app shell, so modules never
// edit router.tsx. The server endpoints exist (workers/api/src/routes/headless.ts); the screens
// (Settings → Headless keys, the "Draft description" button on the product form) are planned.
import type { AnyRoute } from "@tanstack/react-router";

export function headlessRoutes(_appRoute: AnyRoute): AnyRoute[] {
  return [];
}
